<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-approval`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c6.075 0 11 4.925 11 11 0 3.362-1.508 6.372-3.885 8.39L35.133 30H43a2 2 0 012 2v11a2 2 0 01-2 2H5a2 2 0 01-2-2V32a2 2 0 012-2h7.866l4.019-8.61A10.976 10.976 0 0113 13c0-6.075 4.925-11 11-11zm17 32H7v7h34v-7zM24 6a7 7 0 00-7 7c0 1.991.831 3.839 2.265 5.156l.209.184a4 4 0 011.036 4.74L17.28 30h13.44l-3.23-6.92a4 4 0 01.876-4.596l.16-.144A6.974 6.974 0 0031 13a7 7 0 00-7-7z"/></svg>
</template>
<script>

export default {
  name: 'IconApproval',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
